<template>
        <div>
            <div class="container remove-padding-margin" id="dataworkshopsetprod">
                <div class="fixed-top bg-white">
                    <div class="nav-center pageDefault">
                        <div class="row set-row d-flex">
                            <div class="remove-padding navbar-icon-left" data-toggle="modal" data-target="#modalbatalprosprod">
                                <img class="remove-padding-margin" @click="" src="../../assets/img/x2.svg">
                            </div>
                            <div class="text-center remove-padding flex-1 font-weight-600">
                                Tambah Produksi
                            </div>
                            <div class="navbar-icon-right remove-padding">

                            </div>
                        </div>
                    </div>
                </div>
                <main class="add-padding-default">
                    <div class="flex-100">
                        <div class="flex-1 pad-top-50">
                            <div class="animasi-card  bg-transparent d-flex mar-top-16 mar-bottom-16">
                                <div class="font-16 status-login color-206CF"><span class="font-weight-bold color-206CF">Langkah 1/2</span></div>
                            </div>
                            <div class="text-outlets">
                                <h3 class="font-16"><b>Data Workshop</b></h3>
                                <h6>Silahkan masukkan data workshop sebagai lokasi anda melakukan proses produksi</h6>
                            </div>
                            <form action="">
                                <div class="form-group">
                                    <label class="remove-margin require" for="namaCPworkshop">Nama Workshop</label>
                                    <input type="text" class="form-control inputs" id="namaCPworkshop" aria-describedby="emailHelp" placeholder="Clean Laundry" v-model="datadataworkshopproduksi.namaproduksi" v-on:keyup="inputnama">
                                    <label class="remove-margin mar-top-12 require" for="phone">Nomor Telpon Workshop</label>
                                    <div class="input-group remove-padding">
                                        <vue-country-code
                                            @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
                                        </vue-country-code>
                                        <input type="tel" class="form-control inputs" id="phone" placeholder="81757875431" v-model="datadataworkshopproduksi.telpproduksi" v-on:keyup="nomorWaOnkeyup">
                                    </div>
                                    <div class="mod">
                                        <label class=" remove-margin mar-top-12 require">Kota</label>
                                        <Select2 class="" id="select2" v-on:change="cekValidateworkshopproduksi" v-model="datadataworkshopproduksi.selectedkotaproduksi" :options="optionsproduksi"
                                                 :settings="{ placeholder: 'Pilih Kota' }"
                                                 @change="myChangeEvent($event)"/>
                                    </div>

                                    <label class="remove-margin mar-top-12 require" for="alamat">Alamat Lengkap</label>
                                    <textarea type="text" class="form-control inputs" id="alamat" aria-describedby="emailHelp"
                                              placeholder="Jln. Jendral Bersih Selalu No. 1" v-on:keyup="inputalamat" v-model="datadataworkshopproduksi.alamatproduksi"></textarea>
                                </div>
                            </form>
                        </div>
                        <div class="button-lanjut ">
                            <button class="btn btn-login btn-long remove-margin" disabled id="Btndataproduksi" @click="cekconnectiondataprod">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                  id="isClickeddataworkshopsetprod"></span>
                                <span id="textBtndataproduksi">Simpan</span>
                            </button>
                        </div>
                    </div>
                    <div class="modal fade" id="modalbatalprosprod" role="dialog">
                        <div class="modal-dialog modal-lg  bani-modal">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <div class="nav-btn kiri"></div>
                                    <div class="navbar-title text-center">Batal Membuat Workshop</div>
                                    <div class="nav-btn kanan tutup">
                                        <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                    </div>
                                </div>
                                <div class="modal-body">
                                    <div>Apakah anda yakin ingin membatalkan pembuatan workshop baru? </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                            @click="back">Ya, Batalkan
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
            <CreateTahapanSetProd v-bind:class="{hidesection:!iscreatetahapan}" v-bind:datadataworkshopproduksi="datadataworkshopproduksi" v-bind:setidoutlet="setidoutlet"
                                  v-on:backtodataworkshopsetprod="godataworkshopsetprod" v-on:gotodetailworkshop="gotodetailworkshopdata" ref="datatahapansetprod"/>
        </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import CreateTahapanSetProd from "./CreateTahapanSetProd";
    export default {
        name: "DataWorkshopProduksi",
        components: {Select2,CreateTahapanSetProd},
        props:["dataDataWorkshop","setidoutlet"],
        data(){
            return{
                iscreatetahapan:false,
                optionsproduksi: [],
                datadataworkshopproduksi:{
                    telpproduksi:'',
                    selectedkotaproduksi: '1',
                    alamatproduksi:'',
                    namaproduksi:'',
                    idworkshopproduksi:'',
                    idoutlet:this.setidoutlet,
                    telpCode: '',
                },
	            requestHeaders: {
		            headers: {
			            'Authorization': 'Bearer ' + localStorage.getItem('token'),
		            }
	            },
            }
        },
        mounted(){
            $('#isClickeddataworkshopsetprod').hide()
        },
        methods:{
            back(){
                this.datadataworkshopproduksi.namaproduksi='';
                this.datadataworkshopproduksi.telpproduksi='';
                this.datadataworkshopproduksi.alamatproduksi='';
                this.datadataworkshopproduksi.selectedkotaproduksi='1';
                this.$emit('gosetproduksi');
            },
            onSelect({name, iso2, dialCode}) {
              this.datadataworkshopproduksi.telpCode= dialCode;
            },
            gotahapan(){
                this.iscreatetahapan = true;
                $('#dataworkshopsetprod').hide();
                this.$refs.datatahapansetprod.getTahapancreate()
            },

            gotodetailworkshopdata(idworkshop){
                this.$emit('gotodetailworkshop',idworkshop)
            },

            godataworkshopsetprod(){
                this.iscreatetahapan = false;
                $('#dataworkshopsetprod').show();
            },

            inputnama(event){
                var name = event.target.value;
                var handle = name.replace(/[^0-9A-Za-z_.,' -]+/,'');
                this.datadataworkshopproduksi.namaproduksi = handle;
                this.cekValidateworkshopproduksi()
            },

            inputalamat(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z_.,()/' -]+/,'');
                this.datadataworkshopproduksi.alamatproduksi = number
                this.cekValidateworkshopproduksi()
            },

            nomorWaOnkeyup(event) {
                var phoneField = event.target.value;
                var frstCar = phoneField.substring(0,1);
                var firstTel = phoneField.substring(1,15);
                var secCar = phoneField.substring(0,2);
                var secTel = phoneField.substring(2,15);
                var thrdcar = phoneField.substring(0,14);
                var output

                if(frstCar == 0){
                    output = firstTel
                }else if(secCar == this.datadataworkshopproduksi.telpCode){
                    output = secTel
                }else{
                    output = thrdcar
                }

                var number = output.replace(/[^0-9]+/, '');
                this.datadataworkshopproduksi.telpproduksi = number;
                this.cekValidateworkshopproduksi()
            },

            async cekconnectiondataprod(){
                $('#Btndataproduksi').prop('disabled', true);
                $('#isClickeddataworkshopsetprod').show();
                $('#textBtndataproduksi').hide();
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/cek_koneksi',this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#Btndataproduksi').prop('disabled', false);
                            $('#isClickeddataworkshopsetprod').hide();
                            $('#textBtndataproduksi').show();
                            this.cekuniqeworkshopproses()
                        } else {
                            $('#Btndataproduksi').prop('disabled', false);
                            $('#isClickeddataworkshopsetprod').hide();
                            $('#textBtndataproduksi').show();
                            this.$toast.error(response.data.msg)
                        }
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#Btndataproduksi').prop('disabled', false);
	                $('#isClickeddataworkshopsetprod').hide();
	                $('#textBtndataproduksi').show();
                }
            },

            async cekuniqeworkshopproses(){
                this.isClicked = true;
                $('#textBtnCreateWorkshoplist').hide();
                $('#BtnCreateWorkshoplist').prop('disabled', true);
                try {
                    const checknameproses = new FormData;
                    checknameproses.append('nama_workshop',this.datadataworkshopproduksi.namaproduksi);
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/cek_nama_workshop_tersedia', checknameproses, this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.gotahapan();
                            this.isClicked = false;
                            $('#textBtnCreateWorkshoplist').show();
                            $('#BtnCreateWorkshoplist').prop('disabled', false);
                        } else {
                            this.isClicked = false;
                            $('#textBtnCreateWorkshoplist').show();
                            $('#BtnCreateWorkshoplist').prop('disabled', false);
                            this.$toast.error(response.data.msg)
                        }
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#textBtnCreateWorkshoplist').show();
	                $('#BtnCreateWorkshoplist').prop('disabled', false);
                }
            },

            async getkotaworkshopproduksi() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/kota_meta', this.requestHeaders)
                    if (response.status === 200) {
                        var getkotaproduksi = response.data.data;
                        this.optionsproduksi.push({id: "", text: "Pilih Kota"})
                        for (var i = 0; i < getkotaproduksi.length; i++) {
                            this.optionsproduksi.push({id: getkotaproduksi[i].id, text: getkotaproduksi[i].nama})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }

            },
            myChangeEvent(val) {
                this.myValue = val
            },

            cekValidateworkshopproduksi() {
                var kota = this.datadataworkshopproduksi.selectedkotaproduksi;
                var namaworkshop = this.datadataworkshopproduksi.namaproduksi;
                var telp = this.datadataworkshopproduksi.telpproduksi;
                var alamat= this.datadataworkshopproduksi.alamatproduksi;
                var lenPass = namaworkshop.length;
                if (lenPass >= 2 && kota !== '1' && (telp.length >= 10 && telp.length <= 14) && alamat.length>=2) {
                    $('#Btndataproduksi').prop('disabled', false);
                } else {
                    $('#Btndataproduksi').prop('disabled', true);
                }
            },


        }
    }
</script>

<style scoped>
    .hidesection {
        display: none;
    }
</style>